import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {DomSanitizer} from '@angular/platform-browser';
import {environment} from 'src/environments/environment';
import {TrustiiService} from 'src/app/services/trustii.service';
import {DataService, DatasetBannerModel} from 'src/app/services/data.service';
import {SessionService, UserType} from 'src/app/services/session.service';
import {FileService} from 'src/app/services/file.service';

@Component({
  selector: 'app-shared-datasets',
  templateUrl: './datasets.component.html',
  styleUrls: ['./datasets.component.scss']
})
export class SharedDatasetsComponent implements OnInit {
  isReady = false;
  devMode = false;
  name = '';
  inProgress = false;
  elements: any = [];
  user: SessionService['user'] = null;
  meta: any = {
    total: 0,
    nb_page: 1,
    current_page: 1,
    first_page: 1,
    last_page: 1,
    count: 0,
    per_page: 20,
  };
  canUploadDataset = false;

  constructor(private router: Router,
              private trustiiService: TrustiiService,
              private sessionService: SessionService,
              public dataservice: DataService,
              public fileService: FileService,
              public domSanitizer: DomSanitizer,
              public dataetBannerModel: DatasetBannerModel) {
  }

  /**
   * Init component
   */
  ngOnInit() {
    this.canUploadDataset = this.sessionService.canUploadDataset();
    this.devMode = !environment.production;
    this.user = this.sessionService.getUser();
    this.sessionService.tokenData.next({session: true});
    this.getDataSets();
  }

  /**
   * Get datasets
   */
  getDataSets(): void {
    this.isReady = false;
    this.trustiiService.searchDatasets({name: this.name}, this.meta.page, this.meta.per_page).subscribe(
      (res) => {
        this.elements = res.data;
        this.meta = res.meta;
        this.isReady = true;
      },
      (err) => {
        this.isReady = true;
        this.elements = [];
      }
    );
  }

  /**
   * When limit changed
   *
   * @param perPage Nb result per page
   */
  onLimitChanged(perPage: number): void {
    this.meta.per_page = perPage;
    this.getDataSets();
  }

  /**
   * When page changed
   *
   * @param page The page
   */
  onPageChanged(page: number): void {
    this.meta.page = page;
    this.getDataSets();
  }

  /**
   * Format date
   *
   * @param stringDate The date
   * @return Local date
   */
  formatDate(stringDate: string): string {
    const date = new Date(stringDate);
    return date.toLocaleString();
  }

  /**
   * Get days
   *
   * @param stringDate The date
   * @return days ago difference
   */
  getDays(createdDate: string): string {
    const difference = new Date().getTime() - new Date(createdDate).getTime();
    const day = Math.round(Math.abs(difference / (1000 * 60 * 60 * 24)));
    return day > 1 ? day.toString() + ' days' : day.toString() + ' day';
  }

  getDatasetImage(dataset: any): string {
    return (dataset.image === null) ?
      'data:image/png;base64,' + this.dataservice.defaultDatasetIcon :
      'data:image/png;base64,' + dataset.image;
  }

  openDatasetPortal(datasetObject) {
    Object.assign(this.dataetBannerModel.dataset, datasetObject);
    Object.assign(this.dataservice.data, datasetObject);
    this.router.navigateByUrl('datasets/' + datasetObject.id);
  }

  uploadDataset(): void {
    if (!this.canUploadDataset) {
      return;
    }
    this.dataservice.data = { downloadMetadata: false };
    this.router.navigateByUrl('enterprise/datasets/upload');
  }
}
